module.exports = __webpack_public_path__ + "static/media/icon-leads-grey.04ac6501.svg";